module.exports = __webpack_public_path__ + "static/media/galerija_2016 (5).349ac4aa.jpg";